import React from 'react';
import './Waves.css';
import waves from '../../img/main/bg.png'
import waves_mob from '../../img/main/bg_mob.png'

const Waves = () => {
    return (
        <>
            <img className='main_bg main_bg--pc' src={waves} alt="" />
            <img className='main_bg main_bg--mob' src={waves_mob} alt="" />
        </>
    );
};

export default Waves;